import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  list: {
    listStyle: "none",
    margin: 0,
    padding: "0 0 100px 0"
  },
  listItem: {
    marginBottom: 10
  },
  item: {
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
    padding: 25,
    borderRadius: 3,
    display: "flex",
    textDecoration: "none",
    ":hover": {
      background: colour.grey[700]
    }
  },
  notUsed: {
    fontSize: 14,
    fontWeight: 200,
    color: colour.grey[400],
    textAlign: "center"
  },
  itemLeft: { display: "flex" },
  icon: {
    height: 20,
    marginRight: 25
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[200],
    width: "100%",
    display: "block"
  },
  time: {
    marginLeft: "auto",
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[200]
  },
  timeSelectWrapper: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 20
  },
  timeButton: {
    padding: "10px 20px",
    display: "block",
    color: "#ffffff",
    textDecoration: "none",
    textAlign: "center",
    fontWeight: 700,
    fontSize: 18,
    border: 0,
    borderRadius: 30,
    cursor: "pointer",
    background: colour.brand.green,
    ":disabled": {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  timeButtonIcon: {
    marginRight: 10
  },
  timeButtonIconRight: {
    marginLeft: 10
  }
});
